import { TOGGLE_VIEW_STATE } from "../actions/toggleView.action";
import { IToggleViewState } from "../models/root.interface";

const initialState: IToggleViewState = {
    isToggled: false
}

const toggleViewReducer = (state: IToggleViewState = initialState, action: any): IToggleViewState => {

    switch (action.type) {
        case TOGGLE_VIEW_STATE:
            return {
                ...state,
                isToggled: action.isToggled
            }
        default:
            return state;
    }
}

export default toggleViewReducer;